import { Carousel } from 'antd-v5';
import styled, { css } from 'styled-components';

interface DimensionProps {
  $width: number | '100%';
  $height: number;
}

const cssDimension = (value: number | '100%') => (typeof value === 'number' ? `${value}px` : value);

const imageStyles = css<DimensionProps>`
  .ant-image,
  .ant-image-img {
    width: ${({ $width }) => cssDimension($width)};
    height: ${({ $height }) => $height}px;
  }
  .ant-image-img {
    object-fit: cover;
  }
`;

export const SImageBrowser = styled.div<DimensionProps>`
  position: relative;
  width: ${({ $width }) => cssDimension($width)};
  height: ${({ $height }) => $height}px;
  ${imageStyles}
`;

export const SImageCarousel = styled(Carousel)<DimensionProps>`
  width: ${({ $width }) => cssDimension($width)};
  ${imageStyles}

  .slick-prev,
  .slick-next {
    z-index: 1;
    color: ${({ theme }) => theme.color.brand_black};
    opacity: 1;
  }
  .slick-prev {
    left: ${({ $width }) => ($width === 200 ? '4px' : '16px')};
  }
  .slick-next {
    right: ${({ $width }) => ($width === 200 ? '4px' : '16px')};
  }

  .ant5-carousel .slick-dots,
  .slick-dots {
    bottom: 16px;

    li button {
      background: ${({ theme }) => theme.color.grey_metal};
      opacity: 1;
    }

    li.slick-active button {
      background: ${({ theme }) => theme.color.brand_black};
    }
  }
`;

export const SImageSlide = styled.div<DimensionProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${({ $width }) => cssDimension($width)};
  height: ${({ $height }) => $height}px;

  .ant-image,
  .ant-image-img {
    height: 100%;
    width: 100%;
  }
  .ant-image-img {
    object-fit: cover;
  }
`;

export const SImagePlaceholder = styled.div<DimensionProps>`
  display: flex;
  width: ${({ $width }) => cssDimension($width)};
  height: ${({ $height }) => $height}px;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.color.grey_04};
  border-radius: 8px;
`;

export const SThumbnailStrip = styled.div`
  display: flex;
  gap: 24px;
  flex-wrap: wrap;
  justify-content: center;
`;

export const SThumbnail = styled.button<{ $selected: boolean }>`
  padding: 0;
  background: none;
  cursor: pointer;
  border: solid 2px ${({ theme, $selected }) => ($selected ? theme.color.selected : theme.color.grey85)};
  border-radius: 4px;
  overflow: hidden;
  width: 100px;
  height: 100px;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;
